import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import WhatsAppFormApp from '#/WhatsAppFormApp';
import MicroModal from 'micromodal';

export default class WhatsAppFormModal extends Component {
  constructor(props) {
    super(props);

    this.renderWhatsAppForm = this.renderWhatsAppForm.bind(this);
  }

  componentDidMount() {
    if (this.props.open) {
      this.modal = MicroModal.show(this.props.modalId);
    }
  }

  componentDidUpdate() {
    if (this.props.open) {
      this.modal = MicroModal.show(this.props.modalId);
    } else {
      this.modal = MicroModal.close(this.props.modalId);
    }
  }

  renderWhatsAppForm() {
    return (
      <WhatsAppFormApp
        showEmail={this.props.showEmail}
        showContactOptions={this.props.showContactOptions}
        formId={this.props.modalId}
        units={this.props.units}
        unit={this.props.unit}
        filterUnitsByLocation={this.props.filterUnitsByLocation}
        product={this.props.product}
        channel={this.props.channel}
        category={this.props.category}
        brand={this.props.brand}
        link={this.props.link}
        linkPrivacyPolicy={this.props.linkPrivacyPolicy}
        // eslint-disable-next-line react/prop-types
        whatsAppResponder={this.props.whatsAppResponder}
        showUnits={this.props.showUnits}
        showCpf={this.props.showCpf}
        phones={this.props.phones}
        versions={this.props.versions}
        showLocationFields={this.props.showLocationFields}
        contactsWithDynamicRequired={this.props.contactsWithDynamicRequired}
        shouldShowDataPermissions={this.props.shouldShowDataPermissions}
        dataPermissionsCustomText={this.props.dataPermissionsCustomText}
        sendModelAsProduct={this.props.sendModelAsProduct}
        showCustomerType={this.props.showCustomerType}
      />
    );
  }

  render() {
    return (
      <div
        className="modal micromodal-slide"
        id={this.props.modalId}
        aria-hidden="true"
      >
        <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
          <div className="position-relative">
            <i
              className="modal__close modal__overlay-close--form icon icon-close"
              data-micromodal-close
            />
            {this.renderWhatsAppForm()}
          </div>
        </div>
      </div>
    );
  }
}

WhatsAppFormModal.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  modalId: 'modal-whatsapp',
  open: false,
  units: [],
  filterUnitsByLocation: false,
  brand: '-',
  showUnits: true,
  showCpf: false,
  contactsWithDynamicRequired: false,
  shouldShowDataPermissions: false,
  versions: [],
  showLocationFields: false,
  showCustomerType: false,
  showEmail: true,
  showContactOptions: true,
  sendModelAsProduct: false,
};

WhatsAppFormModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  open: PropTypes.bool,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  filterUnitsByLocation: PropTypes.bool,
  unit: PropTypes.string,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  link: PropTypes.string,
  showUnits: PropTypes.bool,
  showCpf: PropTypes.bool,
  showCustomerType: PropTypes.bool,
  showEmail: PropTypes.bool,
  showContactOptions: PropTypes.bool,
  showLocationFields: PropTypes.bool,
  contactsWithDynamicRequired: PropTypes.bool,
  shouldShowDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  phones: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      unit: PropTypes.string,
      area: PropTypes.string,
    }),
  ),
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  sendModelAsProduct: PropTypes.bool,
  linkPrivacyPolicy: PropTypes.string,
};
